import endpoints from "./endpoints";
import api from "./api";
import { LanguageShortModel } from "@medapro-types/ConfigurationManager/ConfigurationManager";

export default {
  async updateLanguages(languages: LanguageShortModel[]) {
    const response = await api.post(endpoints.languages.update, languages);
    return response.data;
  },
  async deleteLanguages(languageIds: number[]) {
    const response = await api.post(endpoints.languages.delete, languageIds);
    return response.data;
  },
  async getIsTranslationStatusEnabled() {
    const response = await api.get(endpoints.languages.translationStatus.get);
    return response.data;
  },
  async updateIsTranslationStatusEnabled(newValue: boolean) {
    const response = await api.post(
      endpoints.languages.translationStatus.update,
      newValue,
      {
        headers: {
          "Content-Type": "application/json"
        }
      },
      true
    );
    return response.data;
  },
  async getAvailableLanguageCodes() {
    const response = await api.get(endpoints.languages.getAvailableLanguageCodes);
    return response.data;
  }
};
